import { DEVICE_ROLES } from '@/features/core/container';
import { MetricResolutionAggregator, MetricResolutionTimeSource, SpotRole } from '@/types/iot-portal';
import { option } from '@/util/container';
import { component } from '../component';
import lg from './general-meter-heat-meter-counter-lg.svg';
import md from './general-meter-heat-meter-counter-md.svg';
import sm from './general-meter-heat-meter-counter-sm.svg';

export default option(DEVICE_ROLES, async () => ({
  name: SpotRole.GENERAL_METER_HEAT_METER_COUNTER,
  label: 'Allgemeinzähler_Wärmemengenzähler',
  shortLabel: 'ALLWZ',
  icons: { sm, md, lg },
  component: component('general-meter-heat-meter-counter/GeneralMeterHeatMeterCounterDevicePanel.vue'),
  aggregationWidget: {
    enabled: true,
    component: component('general-meter-heat-meter-counter/GeneralMeterHeatMeterCounterAggregationWidget.vue'),
  },
  defaultMetricNames: ['currentEnergy'],
  importantMetricNames: ['currentEnergy', 'currentFlow', 'currentVolume'],
  consumption: true,
  aggregationMetricNames: [
    {
      name: 'currentEnergy',
      aggregators: [MetricResolutionAggregator.MEAN],
      timeSource: MetricResolutionTimeSource.START,
    },
    {
      name: 'currentFlow',
      aggregators: [MetricResolutionAggregator.MEAN],
      timeSource: MetricResolutionTimeSource.START,
    },
  ],
}));
